import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import TextBlock from '@/shared/ui/TextBlock';
import { formatChartDate, getBoundaryTimestamps } from '@/shared/utils/dateFormatters';
import BarChart from '@/shared/ui/charts/BarChart';
import { useGetWorkersCountQuery, useGetMinerWorkersQuery } from '@/shared/api/Workers';
import { 
  selectDateRange,
  selectPollingInterval, 
} from "@/processes/Settings";
import { useMinerAccount } from "@/processes/MinerAccounts";

type WorkersChartProps = {
  className?: string;
}

const WorkersChart = (props: WorkersChartProps) => {
  const intl = useIntl();
  const dateRange = useSelector(selectDateRange);
  const pollingInterval = useSelector(selectPollingInterval);
  const { account, miner, coin } = useMinerAccount();

  const { data: workersChartData = [], isSuccess: isWorkersDataSuccess } = useGetWorkersCountQuery({ 
    coin,
    account,
    miner,
    dateRange,
  }, { pollingInterval, skip: !(account || miner) });
  const { data: minerWorkers = [], isSuccess: isMinerWorkersSuccess } = useGetMinerWorkersQuery({ 
    coin,
    account,
    miner,
    dateRange,
  }, { pollingInterval, skip: !(account || miner) });

  const online = String(_get(minerWorkers, 'onlineWorkersCount', 0));
  const offline = String(_get(minerWorkers, 'offlineWorkersCount', 0));

  return (
    <>
      <div className="flex -mx-2 my-4">
        <TextBlock
          size='xl'
          rootClassName='mx-2 min-w-[85px]'
          isLoading={false}
          title={intl.formatMessage({ id: 'workers.online' })}
          value={online}
        />
        <TextBlock
          size='xl'
          rootClassName='mx-2 min-w-[85px]'
          isLoading={false}
          title={intl.formatMessage({ id: 'workers.offline' })}
          value={offline}
        />
      </div>

      <BarChart
        className="w-full h-[180px] mt-6"
        data={workersChartData}
        XAxisProps={{
          dataKey: 'timestamp',
          formatter: (value) => formatChartDate({ date: value, locale: intl.locale, dateRange, ...getBoundaryTimestamps(workersChartData) }),
        }}
        YAxisProps={{
          dataKey: 'count',
        }}
        tooltipLabelFormatter={(value) => formatChartDate({ date: value, locale: intl.locale })}
        lines={[
          {
            name: intl.formatMessage({ id: 'workers' }),
            dataKey: "count",
            stroke: "#00CCAA",
          },
        ]}
      />
    </>
  );
}

export default WorkersChart;
